import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.assign";
import "core-js/modules/web.dom-collections.for-each";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { FiFilter, FiMap, FiList, FiMenu } from 'react-icons/fi';
import { MdRefresh } from 'react-icons/md';
import { CoreButton, Select } from './../../../core';
import useStore from './../store.js';
import { CPAL_METRICS, CPAL_FILTER_TABS } from './../../../../constants/metrics';
import TabSeries from './TabSeries';

var PanelFilterView = function PanelFilterView(_ref) {
  var props = _extends({}, _ref); // Generic state setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Default filter tab

  var defaultFilterTab = useStore(function (state) {
    return state.defaultFilterTab;
  }); // Active filter tab

  var activeFilterTab = useStore(function (state) {
    return state.activeFilterTab;
  }); // Default metric

  var defaultMetric = useStore(function (state) {
    return state.defaultMetric;
  }); // Active metric

  var activeMetric = useStore(function (state) {
    return state.activeMetric;
  }); // Generate tabs for every metric with tab_level set to 0

  var tabs = [];
  CPAL_METRICS.forEach(function (el) {
    if (el.tab_level === 0) {
      tabs.push(el.id);
    }
  });
  /** Returns title translation placeholder for a tab **/

  var getTabTitle = function getTabTitle(id) {
    var obj = CPAL_FILTER_TABS.find(function (el) {
      return el.id === id;
    });
    return obj.title;
  };
  /** Process select items for tabs **/


  var selectItems = [];
  tabs.forEach(function (el) {
    var item = CPAL_METRICS.find(function (i) {
      return i.id === el;
    });
    selectItems.push({
      id: item.id,
      label: getTabTitle(item.tab),
      active: item.tab === activeFilterTab ? true : false
    });
  });

  var _handleSelect = function handleSelect(e) {
    // console.log('category selected, ', e.currentTarget.id)
    var tabId = CPAL_METRICS.find(function (i) {
      return i.id === e.currentTarget.id;
    }).tab;
    var default_metric = CPAL_FILTER_TABS.find(function (el) {
      return el.id === tabId;
    }).default_metric; // console.log('default_metric, ', default_metric)

    setStoreValues({
      activeFilterTab: tabId,
      activeMetric: default_metric,
      activeQuintiles: [1, 1, 1, 1, 1]
    });
  };

  var handleResetClick = function handleResetClick() {
    // console.log('handleResetClick()')
    setStoreValues({
      activeFilterTab: defaultFilterTab,
      activeMetric: defaultMetric,
      activeQuintiles: [1, 1, 1, 1, 1]
    });
  };

  var getSelectLabel = function getSelectLabel() {
    // console.log('getSelectLabel')
    var tab = CPAL_FILTER_TABS.find(function (el) {
      return el.id === activeFilterTab;
    }); // console.log('tab, ', tab)

    return tab ? i18n.translate(tab.title) : null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: clsx('map-panel-slideout-filters', activeFilterTab ? 'active-tab-' + activeFilterTab : 'active-tab-default')
  }, /*#__PURE__*/React.createElement("h3", null, i18n.translate('UI_MAP_PANEL_HEADING')), /*#__PURE__*/React.createElement("p", {
    id: "label_filter_select"
  }, i18n.translate('UI_MAP_PANEL_SELECT')), /*#__PURE__*/React.createElement("div", {
    className: "map-panel-controls"
  }, /*#__PURE__*/React.createElement(Select, {
    label: getSelectLabel(),
    items: selectItems,
    handleSelect: function handleSelect(e) {
      return _handleSelect(e);
    },
    ariaLabelledby: "label_filter_select",
    ariaLabel: i18n.translate('UI_MAP_PANEL_SELECT')
  }), /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_reset_filter",
    label: i18n.translate("UI_MAP_BUTTON_RESET_FILTER"),
    tooltip: "right",
    onClick: handleResetClick,
    color: "light",
    className: clsx('map-panel-filter-reset')
  }, /*#__PURE__*/React.createElement(MdRefresh, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("UI_MAP_BUTTON_RESET_FILTER")))), /*#__PURE__*/React.createElement("div", {
    className: "map-panel-instructions",
    dangerouslySetInnerHTML: {
      __html: i18n.translate('UI_MAP_FILTER_INSTRUCTIONS', {
        icon: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></svg>'
      })
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters-panel-parent"
  }, /*#__PURE__*/React.createElement(TabSeries, {
    tabs: tabs,
    metrics: CPAL_METRICS,
    activeTab: activeFilterTab
  })));
};

export default PanelFilterView;